import React from 'react';
import TabShell from '@/components/tabs/TabShell';

const LandingPage: React.FC = () => {
  return <TabShell />;
};

export default LandingPage;
